import Checkbox from '@ixigo/iui/Checkbox';
import Typography from '@ixigo/iui/Typography';
import { useEffect, useState } from 'react';
import { TestId } from '../../enums/test';
import { CheckboxListProps, ListItem } from './index.types';

function CheckboxList({ data, onChange }: CheckboxListProps) {
    const [selection, setSelection] = useState<{
        [id: ListItem['id']]: ListItem['value'];
    }>({});

    useEffect(() => {
        onChange(data.filter((item) => !!selection[item.id]));
    }, [selection, data]);

    const onSelect = (item: ListItem) => {
        if (item.disabled) return;

        setSelection((prevSelection = {}) => {
            const newSelection = { ...prevSelection };
            if (newSelection[item.id]) delete newSelection[item.id];
            else newSelection[item.id] = item;
            return newSelection;
        });
    };

    return (
        <div className='flex flex-col gap-0.5' data-testid={TestId.CHECKBOX_LIST}>
            {data.map((item, index) => (
                <div
                    key={item.id}
                    className='flex items-center gap-5 p-5'
                    onClick={() => onSelect(item)}
                    data-testid={`${TestId.CHECKBOX_WRAPPER}${index}`}
                >
                    <Checkbox
                        checked={!!selection[item.id]}
                        className='m-0.5'
                        disabled={item.disabled}
                        data-testid={`${TestId.CHECKBOX}${index}`}
                    />
                    <Typography variant='body-md'>{item.label}</Typography>
                </div>
            ))}
        </div>
    );
}

export default CheckboxList;
